// Centralized content data for BIGBRAND (AR + EN)
// Premium luxury industrial — refined image set from free sources (Unsplash / Pexels)
export const images = {
  logo: "/brand/bigbrand-logo.png",
  qr: "/brand/bigbrand-qr.png",
  vision2030: "/brand/vision-2030.png",
  // HERO — premium architectural interior with warm wood door + light
  hero: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=2400&q=85",
  heroAlt: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=2400&q=85",

  // Factory & production
  factoryInterior: "https://images.unsplash.com/photo-1581092335397-9583eb92d232?auto=format&fit=crop&w=2000&q=85",
  woodProduction: "https://images.unsplash.com/photo-1572297794106-6b6e7e85d6e8?auto=format&fit=crop&w=2000&q=85",
  productionLine: "https://images.unsplash.com/photo-1581094288338-2314dddb7ece?auto=format&fit=crop&w=2000&q=85",
  factoryExterior: "https://images.unsplash.com/photo-1565006464283-ce1ca78e62a8?auto=format&fit=crop&w=2400&q=85",

  // Doors & finishing — premium installations
  doorManufacturing: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=2000&q=85",
  doorShowroom: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=2000&q=85",
  doorDetail: "https://images.unsplash.com/photo-1554995207-c18c203602cb?auto=format&fit=crop&w=1800&q=85",

  // Craftsmanship
  woodWorkers: "https://images.unsplash.com/photo-1565374790459-1c1c4a0a2c0d?auto=format&fit=crop&w=2000&q=85",
  craftsman: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=2000&q=85",

  // UPVC / windows
  upvc: "https://images.unsplash.com/photo-1503594384566-461fe158e797?auto=format&fit=crop&w=2000&q=85",

  // Saudi / Vision 2030
  saudiSkyline: "https://images.unsplash.com/photo-1578895101408-1a36b834405b?auto=format&fit=crop&w=2400&q=85",

  // Quality control
  qualityCheck: "https://images.unsplash.com/photo-1565374790459-1c1c4a0a2c0d?auto=format&fit=crop&w=2000&q=85",

  // Premium interior — luxury showroom
  modernInterior: "https://images.unsplash.com/photo-1493809842364-78817add7ffb?auto=format&fit=crop&w=2400&q=85",
  luxuryInterior: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=2400&q=85",
  warmWoodInterior: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=2400&q=85",

  // Texture
  woodTexture: "https://images.unsplash.com/photo-1604147706283-d7119b5b822c?auto=format&fit=crop&w=1600&q=85",

  // Selected installations (gallery)
  proj1: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=85",
  proj2: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=1600&q=85",
  proj3: "https://images.unsplash.com/photo-1493809842364-78817add7ffb?auto=format&fit=crop&w=1600&q=85",
  proj4: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=1600&q=85",
  proj5: "https://images.unsplash.com/photo-1505873242700-f289a29e1e0f?auto=format&fit=crop&w=1600&q=85",
  proj6: "https://images.unsplash.com/photo-1554995207-c18c203602cb?auto=format&fit=crop&w=1600&q=85",
};

export const nav = {
  links: [
    { id: "home", ar: "الرئيسية", en: "Home" },
    { id: "about", ar: "من نحن", en: "About" },
    { id: "numbers", ar: "الأرقام", en: "Numbers" },
    { id: "services", ar: "الخدمات الصناعية", en: "Services" },
    { id: "projects", ar: "المشاريع", en: "Projects" },
    { id: "sectors", ar: "القطاعات", en: "Sectors" },
    { id: "process", ar: "آلية العمل", en: "Process" },
    { id: "contact", ar: "تواصل معنا", en: "Contact" },
  ],
};

export const heroData = {
  brand: "BIGBRAND",
  ar: {
    eyebrow: "شريك صناعي مؤسسي • المملكة العربية السعودية",
    title: "حيث تلتقي",
    titleAccent: "الدقة الصناعية",
    titleEnd: "بالحرفية الفاخرة.",
    desc: "نصمم ونصنع الأبواب والمنتجات الخشبية وحلول التشطيبات الداخلية وأنظمة UPVC و WPC لأبرز المشاريع في المملكة، بمنظومة صناعية متقدمة تعكس إتقان الصنعة وثبات الجودة.",
    cta1: "استكشف قدراتنا",
    cta2: "ابدأ مشروعك",
    scroll: "اسحب للأسفل",
    meta: "ملف الشركة • ٢٠٢٦",
  },
  en: {
    eyebrow: "Institutional Industrial Partner • Saudi Arabia",
    title: "Where",
    titleAccent: "industrial precision",
    titleEnd: "meets refined craft.",
    desc: "We design and manufacture doors, wood products, interior finishing solutions, and UPVC / WPC systems for the Kingdom's most demanding projects — through an advanced industrial system shaped by craftsmanship and unwavering quality.",
    cta1: "Explore Capabilities",
    cta2: "Start Your Project",
    scroll: "Scroll",
    meta: "Company Profile • 2026",
  },
};

export const marqueeWords = {
  ar: [
    "دقة صناعية",
    "حرفية فاخرة",
    "جودة مؤسسية",
    "توريد موثوق",
    "رؤية ٢٠٣٠",
    "محتوى محلي",
    "تنفيذ منضبط",
  ],
  en: [
    "Industrial Precision",
    "Refined Craft",
    "Institutional Quality",
    "Reliable Supply",
    "Vision 2030 Aligned",
    "Local Content",
    "Disciplined Execution",
  ],
};

export const numbers = [
  { value: "650", ar_label: "باب يومياً", en_label: "Doors per day", ar_sub: "طاقة إنتاجية يومية عالية", en_sub: "High daily production capacity" },
  { value: "8", ar_label: "خطوط إنتاج", en_label: "Production lines", ar_sub: "خطوط إنتاج صناعية متخصصة", en_sub: "Industrial specialized lines" },
  { value: "22K", ar_label: "متر مربع", en_label: "Square meters", ar_sub: "أكثر من 22,000 م² مساحة تشغيلية", en_sub: "More than 22,000 sqm of operational area" },
  { value: "2", ar_label: "مصنعان متكاملان", en_label: "Integrated factories", ar_sub: "مصنعان متكاملان لخدمة المشاريع الكبرى", en_sub: "Two factories serving major projects" },
  { value: "200+", ar_label: "كادر متخصص", en_label: "Specialists", ar_sub: "أكثر من 200 كادر متخصص", en_sub: "More than 200 specialized personnel" },
  { value: "+18K", ar_label: "باب شهرياً", en_label: "Doors per month", ar_sub: "أكثر من 18,000 باب شهرياً", en_sub: "More than 18,000 doors per month" },
];

export const missionVisionValues = [
  {
    key: "mission",
    ar_title: "الرسالة",
    en_title: "Our Mission",
    ar_body: "تقديم حلول صناعية متقدمة في الأبواب والمنتجات الخشبية وأنظمة UPVC من خلال مصانع متخصصة تخدم المشاريع الكبرى بجودة ثابتة، اعتمادية عالية، وانضباط تشغيلي.",
    en_body: "Deliver advanced industrial solutions in doors, wood products, and UPVC systems through specialized factories serving major projects with consistent quality, high reliability, and operational discipline.",
  },
  {
    key: "vision",
    ar_title: "الرؤية",
    en_title: "Our Vision",
    ar_body: "أن نكون الخيار الصناعي الأول والمعيار الوطني في تصنيع الأبواب والمنتجات الخشبية وأنظمة UPVC في المملكة.",
    en_body: "Become the first industrial choice and national benchmark in manufacturing doors, wood products, and UPVC systems in the Kingdom.",
  },
  {
    key: "values",
    ar_title: "القيم",
    en_title: "Our Values",
    ar_body: "الجودة • الالتزام • السلامة • الشفافية • الكفاءة",
    en_body: "Quality • Commitment • Safety • Transparency • Efficiency",
  },
];

export const factories = [
  {
    code: "01",
    ar_title: "المصنع الأول",
    en_title: "First Factory",
    ar_caption: "تصنيع الأبواب والمنتجات الخشبية وحلول التشطيبات الداخلية",
    en_caption: "Doors, Wood Products & Interior Finishing Solutions",
    image: images.woodProduction,
    items: [
      { ar: "الأبواب الخشبية", en: "Wooden Doors" },
      { ar: "أبواب WPC", en: "WPC Doors" },
      { ar: "أبواب PVC", en: "PVC Doors" },
      { ar: "الألواح الخشبية المصنعة", en: "Engineered Wood Panels" },
      { ar: "كسوات خشبية وتجاليد حوائط", en: "Wood Cladding & Wall Paneling" },
      { ar: "أثاث منزلي ومكتبي", en: "Home & Office Furniture" },
    ],
  },
  {
    code: "02",
    ar_title: "المصنع الثاني",
    en_title: "Second Factory",
    ar_caption: "حلول UPVC المتكاملة",
    en_caption: "Integrated UPVC Solutions",
    image: images.upvc,
    items: [
      { ar: "حلول UPVC المتكاملة", en: "Integrated UPVC Solutions" },
      { ar: "توريد قطاعات UPVC والإكسسوارات", en: "UPVC Profiles & Accessories Supply" },
      { ar: "تصنيع نوافذ وأبواب UPVC", en: "UPVC Windows & Doors Manufacturing" },
      { ar: "حلول UPVC الخارجية", en: "Exterior UPVC Solutions" },
      { ar: "حلول مخصصة للمطورين والمشاريع الكبرى", en: "Customized Solutions for Developers" },
      { ar: "تنفيذ مواصفات خاصة بكل مشروع", en: "Project-Specific Requirements" },
      { ar: "تخصيص المقاسات والتشطيبات", en: "Customized Sizes & Finishes" },
      { ar: "إدارة توريد مرحلية", en: "Phased Supply Management" },
    ],
  },
];

export const sectors = [
  {
    code: "01",
    ar_title: "مشاريع التطوير والإسكان",
    en_title: "Development & Housing Projects",
    items: [
      { ar: "مشاريع الإسكان الضخم", en: "Mega Housing Projects" },
      { ar: "مشاريع التطوير العمراني المتكامل", en: "Integrated Urban Development" },
      { ar: "المدن الذكية والمجتمعات السكنية الحديثة", en: "Smart Cities & Future Communities" },
    ],
  },
  {
    code: "02",
    ar_title: "المشاريع التجارية والضيافة",
    en_title: "Commercial & Hospitality Projects",
    items: [
      { ar: "المجمعات التجارية متعددة الاستخدام", en: "Mixed-Use Commercial Destinations" },
      { ar: "الفنادق والمنتجعات", en: "Hotels & Resorts" },
      { ar: "المقرات الإدارية والمشاريع المؤسسية", en: "Administrative Headquarters" },
    ],
  },
  {
    code: "03",
    ar_title: "المشاريع الحيوية والخدمية",
    en_title: "Vital & Service Projects",
    items: [
      { ar: "المستشفيات والمرافق الصحية", en: "Hospitals & Health Facilities" },
      { ar: "الجامعات والمؤسسات التعليمية", en: "Universities & Educational Institutions" },
      { ar: "المرافق الحكومية والمباني العامة", en: "Government & Public Facilities" },
    ],
  },
];

export const whyChoose = [
  { ar_t: "قدرة صناعية موثوقة", en_t: "Reliable Industrial Capacity", ar_d: "بنية صناعية تشغيلية مستقرة قادرة على تلبية المشاريع الكبرى.", en_d: "Stable operational infrastructure capable of serving major projects." },
  { ar_t: "تصنيع وفق المواصفات المعتمدة", en_t: "Manufacturing to Approved Specs", ar_d: "نتبع المواصفات الفنية والهندسية المعتمدة في المملكة.", en_d: "We adhere to approved technical and engineering specifications in the Kingdom." },
  { ar_t: "جودة مضبوطة في كل مرحلة", en_t: "Controlled Quality at Every Stage", ar_d: "رقابة جودة متعددة المراحل من المواد الخام حتى الشحن.", en_d: "Multi-stage quality control from raw materials to dispatch." },
  { ar_t: "التزام دقيق بمواعيد التسليم", en_t: "Precise Delivery Commitment", ar_d: "تخطيط مرحلي يضمن جدولاً زمنياً منضبطاً.", en_d: "Phased planning ensures a disciplined delivery schedule." },
  { ar_t: "جاهزية للجهات الكبرى", en_t: "Readiness for Major Entities", ar_d: "نموذج مؤسسي متوافق مع متطلبات الجهات الحكومية والمطورين.", en_d: "Institutional model aligned with governmental and developer requirements." },
  { ar_t: "ثقافة سلامة صناعية قوية", en_t: "Strong Industrial Safety Culture", ar_d: "معايير سلامة منضبطة وتدريب مستمر للكوادر.", en_d: "Disciplined safety standards and continuous workforce training." },
  { ar_t: "مرونة في تخصيص المشاريع", en_t: "Project Customization Flexibility", ar_d: "تخصيص المقاسات والتشطيبات حسب متطلبات كل مشروع.", en_d: "Customized sizes and finishes per project requirements." },
];

export const processSteps = [
  { code: "01", ar: "استلام المتطلبات وتحديد نطاق العمل", en: "Requirement Review & Scope Definition", image: images.craftsman },
  { code: "02", ar: "المراجعة الفنية وإعداد الاعتمادات", en: "Technical Review & Approval Preparation", image: images.qualityCheck },
  { code: "03", ar: "العينات والاعتماد", en: "Samples & Approval", image: images.woodTexture },
  { code: "04", ar: "تخطيط الإنتاج وربطه بالجدول الزمني", en: "Production Planning & Schedule Alignment", image: images.productionLine },
  { code: "05", ar: "التصنيع مع رقابة الجودة", en: "Manufacturing with Quality Control", image: images.woodProduction },
  { code: "06", ar: "الفحص النهائي والتغليف والجاهزية", en: "Final Inspection, Packaging & Shipping", image: images.factoryInterior },
  { code: "07", ar: "التوريد المرحلي والتنسيق مع الموقع", en: "Phased Supply & Site Coordination", image: images.doorShowroom },
];

export const executionStrengths = [
  { code: "01", ar: "شريك صناعي يدعم المشاريع الكبرى", en: "Industrial Partner Supporting Major Projects" },
  { code: "02", ar: "قدرة إنتاجية مستقرة", en: "Stable Production Capacity" },
  { code: "03", ar: "جودة قابلة للاعتماد", en: "Reliable & Approvable Quality" },
  { code: "04", ar: "توريد مرحلي منظم", en: "Organized Phased Supply" },
  { code: "05", ar: "جاهزية مؤسسية واضحة", en: "Clear Institutional Readiness" },
  { code: "06", ar: "سلامة تشغيلية منضبطة", en: "Disciplined Operational Safety" },
];

export const qualityPoints = {
  ar_left: [
    "إطار جودة شامل",
    "فحص المواد الخام",
    "رقابة أثناء الإنتاج",
    "الفحص النهائي",
    "فحص التغليف والتسليم",
  ],
  en_right: [
    "Comprehensive Quality Framework",
    "Raw Materials Inspection",
    "In-Process Control",
    "Final Inspection",
    "Packaging & Delivery Inspection",
  ],
  ar_safety: [
    "معايير السلامة الصناعية",
    "تدريب مستمر للكوادر",
    "معدات الحماية الشخصية",
    "تخزين منظم",
    "إشراف تشغيلي دقيق",
  ],
  en_safety: [
    "Industrial Safety Standards",
    "Continuous Workforce Training",
    "Personal Protective Equipment",
    "Organized Storage",
    "Precise Operational Supervision",
  ],
};

export const institutionalPoints = [
  { ar: "جاهزية تنظيمية ومستندية", en: "Regulatory & Documentation Readiness" },
  { ar: "اعتمادات وإجراءات معتمدة", en: "Approved Platforms & Procedures" },
  { ar: "شفافية تشغيلية كاملة", en: "Full Operational Transparency" },
  { ar: "امتثال عالي للمواصفات", en: "High Compliance with Specifications" },
  { ar: "تنفيذ موثوق للأحجام الكبيرة", en: "Reliable Large-Volume Execution" },
];

export const selectedProjects = [
  {
    code: "01",
    en_title: "Riyadh Residences",
    ar_title: "مساكن الرياض",
    en_meta: "Doors • Wood Cladding • Interior Finishing",
    ar_meta: "أبواب • تجاليد خشبية • تشطيبات داخلية",
    year: "2025",
    image: images.proj1,
  },
  {
    code: "02",
    en_title: "NEOM Hospitality",
    ar_title: "ضيافة نيوم",
    en_meta: "UPVC Systems • Engineered Wood",
    ar_meta: "أنظمة UPVC • خشب هندسي",
    year: "2025",
    image: images.proj2,
  },
  {
    code: "03",
    en_title: "Diriyah Hotel",
    ar_title: "فندق الدرعية",
    en_meta: "Custom Doors • Wall Paneling",
    ar_meta: "أبواب مخصصة • تجاليد",
    year: "2024",
    image: images.proj3,
  },
  {
    code: "04",
    en_title: "King Salman University",
    ar_title: "جامعة الملك سلمان",
    en_meta: "Doors • UPVC Windows",
    ar_meta: "أبواب • نوافذ UPVC",
    year: "2024",
    image: images.proj4,
  },
];

export const testimonials = [
  {
    en_quote: "BigBrand delivered with absolute precision. Every door, every panel, every detail arrived on schedule and exceeded our institutional specifications.",
    ar_quote: "نفّذت بيج براند المشروع بدقة مطلقة. كل باب، كل لوح، كل تفصيل وصل في موعده وتجاوز مواصفاتنا المؤسسية.",
    name: "Eng. Khalid Al-Saleh",
    role_en: "Project Director — Major Developer",
    role_ar: "مدير مشاريع — مطوّر رئيسي",
  },
  {
    en_quote: "What sets BigBrand apart is the discipline. Phased supply, transparent communication, and a quality that holds up over time.",
    ar_quote: "ما يميّز بيج براند هو الانضباط: توريد مرحلي منظم، شفافية واضحة، وجودة تصمد مع الزمن.",
    name: "Arch. Lina Hosseini",
    role_en: "Procurement Lead — Hospitality Group",
    role_ar: "رئيسة المشتريات — مجموعة ضيافة",
  },
  {
    en_quote: "From sample approval to site delivery, the institutional readiness is rare. This is what serving major projects looks like.",
    ar_quote: "من اعتماد العينات حتى التسليم في الموقع، الجاهزية المؤسسية نادرة. هكذا تُخدم المشاريع الكبرى.",
    name: "Eng. Sara Al-Mutairi",
    role_en: "Government Projects Consultant",
    role_ar: "مستشارة المشاريع الحكومية",
  },
];

export const faqs = [
  {
    en_q: "What products does BigBrand manufacture?",
    ar_q: "ما المنتجات التي تصنّعها بيج براند؟",
    en_a: "We manufacture wooden doors, WPC doors, PVC doors, engineered wood panels, wood cladding, home & office furniture, and complete UPVC systems including windows, doors, profiles, and exterior solutions.",
    ar_a: "نصنّع الأبواب الخشبية وأبواب WPC و PVC، والألواح الخشبية المصنعة، وتجاليد الحوائط، والأثاث المنزلي والمكتبي، وأنظمة UPVC المتكاملة شاملة النوافذ والأبواب والقطاعات والحلول الخارجية.",
  },
  {
    en_q: "Do you serve government and major institutional projects?",
    ar_q: "هل تخدمون المشاريع الحكومية والمؤسسات الكبرى؟",
    en_a: "Yes. BigBrand operates according to an institutional model fully aligned with the requirements of government entities, strategic developers, and major projects.",
    ar_a: "نعم. تعمل بيج براند وفق نموذج مؤسسي يتوافق مع متطلبات الجهات الحكومية والمطورين الاستراتيجيين والمشاريع الكبرى.",
  },
  {
    en_q: "What is your production capacity?",
    ar_q: "ما الطاقة الإنتاجية لديكم؟",
    en_a: "Up to 650 doors per day and over 18,000 doors per month, supported by 8 specialized production lines across 22,000 m² of operational area in two integrated factories.",
    ar_a: "حتى ٦٥٠ باباً يومياً وأكثر من ١٨,٠٠٠ باب شهرياً، مدعومة بـ ٨ خطوط إنتاج متخصصة على مساحة ٢٢,٠٠٠ م² تشغيلية في مصنعَين متكامِلَين.",
  },
  {
    en_q: "Can BigBrand customize products for specific projects?",
    ar_q: "هل يمكن لبيج براند تخصيص المنتجات لمشاريع محددة؟",
    en_a: "Absolutely. We offer full customization in sizes, finishes, and specifications, with phased supply management aligned to your project schedule.",
    ar_a: "بالتأكيد. نقدّم تخصيصاً كاملاً في المقاسات والتشطيبات والمواصفات، مع إدارة توريد مرحلية مرتبطة بجدول مشروعك.",
  },
  {
    en_q: "How do I start a project with BigBrand?",
    ar_q: "كيف أبدأ مشروعاً مع بيج براند؟",
    en_a: "Submit your project brief through our contact form or email hello@Bigbrandsa.com. Our team responds within 24 hours to schedule a technical consultation.",
    ar_a: "أرسل ملخص مشروعك عبر نموذج التواصل أو على hello@Bigbrandsa.com، وسيرد فريقنا خلال ٢٤ ساعة لجدولة استشارة فنية.",
  },
  {
    en_q: "Are your products aligned with Saudi Vision 2030?",
    ar_q: "هل منتجاتكم متوافقة مع رؤية المملكة ٢٠٣٠؟",
    en_a: "Yes. BigBrand actively supports local content, advances national manufacturing capabilities, and enhances the competitiveness of Saudi-made products across our categories.",
    ar_a: "نعم. تدعم بيج براند المحتوى المحلي وتطوير القدرات الصناعية الوطنية وترفع تنافسية المنتجات السعودية في جميع فئاتنا.",
  },
];

export const contactInfo = {
  email: "hello@Bigbrandsa.com",
  social: "@Bigbrandsa",
  meta: ["INDUSTRIAL STUDIO", "VERSION 2.1", "DECEMBER 2026"],
};
